/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {Role} from '../models/Role';
import type {RoleList} from '../models/RoleList';

export interface GetProductRolesByIds$Request {
    requestBody: Array<string>;
}

export interface GetProductRolesByIds$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProductRolesByIdsRequest = createAction<PayloadData<void, GetProductRolesByIds$Request>>('PRODUCT_ENTITLEMENTS_ROLE__GET_PRODUCT_ROLES_BY_IDS__REQUEST');
export const getProductRolesByIdsSuccess = createAction<PayloadData<{ [key: string]: Role; }, GetProductRolesByIds$Request>>('PRODUCT_ENTITLEMENTS_ROLE__GET_PRODUCT_ROLES_BY_IDS__SUCCESS');
export const getProductRolesByIdsFailure = createAction<PayloadData<Error, GetProductRolesByIds$Request, true>>('PRODUCT_ENTITLEMENTS_ROLE__GET_PRODUCT_ROLES_BY_IDS__FAILURE');

export const getProductRolesByIdsActions = [
    getProductRolesByIdsRequest,
    getProductRolesByIdsSuccess,
    getProductRolesByIdsFailure
] as const;

/**
 * @param {Array<string>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProductRolesByIds = (meta: GetProductRolesByIds$Request, config?: GetProductRolesByIds$Config) => {
    return {
        CALL_API: {
            types: getProductRolesByIdsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/product/entitlements/roles`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetProductRolesWithoutRelations$Request {
    pageSize: number;
    pageNumber: number;
}

export interface GetProductRolesWithoutRelations$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProductRolesWithoutRelationsRequest = createAction<PayloadData<void, GetProductRolesWithoutRelations$Request>>('PRODUCT_ENTITLEMENTS_ROLE__GET_PRODUCT_ROLES_WITHOUT_RELATIONS__REQUEST');
export const getProductRolesWithoutRelationsSuccess = createAction<PayloadData<RoleList, GetProductRolesWithoutRelations$Request>>('PRODUCT_ENTITLEMENTS_ROLE__GET_PRODUCT_ROLES_WITHOUT_RELATIONS__SUCCESS');
export const getProductRolesWithoutRelationsFailure = createAction<PayloadData<Error, GetProductRolesWithoutRelations$Request, true>>('PRODUCT_ENTITLEMENTS_ROLE__GET_PRODUCT_ROLES_WITHOUT_RELATIONS__FAILURE');

export const getProductRolesWithoutRelationsActions = [
    getProductRolesWithoutRelationsRequest,
    getProductRolesWithoutRelationsSuccess,
    getProductRolesWithoutRelationsFailure
] as const;

/**
 * @param {number} meta.pageSize
 * @param {number} meta.pageNumber
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProductRolesWithoutRelations = (meta: GetProductRolesWithoutRelations$Request, config?: GetProductRolesWithoutRelations$Config) => {
    const TRANSPORT_GET_PARAMS = {
        pageSize: meta.pageSize,
        pageNumber: meta.pageNumber,
    };
    return {
        CALL_API: {
            types: getProductRolesWithoutRelationsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/product/entitlements/roles`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

